import "./ScoutingBadge.css";

import { useDispatch, useSelector } from "react-redux";

import { Badge } from "reactstrap";
import PropTypes from "prop-types";
import { resetScouting } from "../../../actions/resultMap";

export const ScoutingBadge = ({ onClick }) => {
  const dispatch = useDispatch();
  const handleCloseScouting = (e) => {
    // stop propagation to prevent the opening of the traits selector
    e.stopPropagation();
    onClick(false);
    dispatch(resetScouting());
  };
  const [selectedScoutingTrait] = useSelector(({ resultMap }) => [
    resultMap.selectedScoutingTrait,
  ]);

  return (
    <Badge
      className="scouting-badge clickable"
      onClick={() => onClick((prev) => !prev)}
    >
      <i className="fa-solid fa-camera " />
      <div className="scouting-content-items">
        <div className="scouting-content">
          <Badge color="danger" className="text-truncate w-100">
            {selectedScoutingTrait
              ? selectedScoutingTrait.label
              : "No traits available"}
          </Badge>
        </div>
      </div>
      <i
        className="fa-solid fa-xmark close-icon"
        onClick={handleCloseScouting}
      />
    </Badge>
  );
};
ScoutingBadge.propTypes = {
  onClick: PropTypes.func.isRequired,
};
